import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, API, buildError } from '../../api/apis';
import { ApiResponse, ValidateScmCodeRequest } from '../../interfaces/interfaces';

export const validateScmCodeService = createApi({
  reducerPath: 'validateScmCodeApi',
  tagTypes: ['ValidateScmCode'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders
  }),
  endpoints: (builder) => ({
    validateAssociationCode: builder.mutation({
      query: ({ payload }: { payload: ValidateScmCodeRequest }) => ({
        url: `${API.VALIDATE_SCM_CODE()}`,
        method: 'POST',
        body: payload,
      }),
      transformResponse: (response: ApiResponse) => {
        return response?.ResponseStatus?.ErrorCode === 0;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useValidateAssociationCodeMutation } = validateScmCodeService;
